import { ROLES } from "@/utils/constants.js";

export function isStaffRole(role) {
    return role === ROLES.ADMIN || role === ROLES.MANAGER || role === ROLES.SECRETARY;
}

export function isAdminRole(role) {
    return role === ROLES.ADMIN;
}

/** Menu section ids the role may open. */
export function staffMenuSectionAllowed(role, sectionId) {
    if (!isStaffRole(role)) {
        return false;
    }
    if (isAdminRole(role)) {
        return true;
    }
    const managerSecretary = new Set([
        "orders",
        "products",
        "lots",
        "customers",
        "carts",
        "voeux",
        "advertisements",
        "reviews",
        "employees",
        "profile",
        "password"
    ]);
    return managerSecretary.has(sectionId);
}

export function canDeleteOrder(role) {
    return isAdminRole(role);
}

export function canDeleteProduct(role) {
    return isAdminRole(role);
}

export function canWriteLot(role) {
    return isAdminRole(role);
}

export function canDeleteLot(role) {
    return isAdminRole(role);
}

export function canSeeCostPrice(role) {
    return isAdminRole(role);
}

export function canWriteProductPriceAndStatus(role) {
    return isAdminRole(role);
}

export function canDeleteCustomerAccount(role) {
    return isAdminRole(role);
}

export function canWriteGeneralSettings(role) {
    return isAdminRole(role);
}

export function canWriteLegalSettings(role) {
    return isAdminRole(role);
}

export function canWriteShops(role) {
    return isAdminRole(role);
}

/** Add / remove shop locations — Admin only. */
export function canManageShopStructure(role) {
    return isAdminRole(role);
}

export function canApproveAdvertisement(role) {
    return isAdminRole(role);
}

export function canPublishAdvertisementLive(role) {
    return isAdminRole(role);
}

/** Manager/Secretary may mutate ads only when not live. */
export function canMutateAdvertisement(role, status) {
    if (isAdminRole(role)) {
        return true;
    }
    if (!isStaffRole(role)) {
        return false;
    }
    return status !== "PUBLISHED";
}

export function canMutateEmployees(role) {
    return isAdminRole(role);
}

export const STAFF_ROLE_LABELS = {
    [ROLES.ADMIN]: "Administrateur",
    [ROLES.MANAGER]: "Manager",
    [ROLES.SECRETARY]: "Secrétaire"
};
